import { render, staticRenderFns } from "./KETBetriebsordner.vue?vue&type=template&id=3cd56d24&scoped=true&"
import script from "./KETBetriebsordner.vue?vue&type=script&lang=js&"
export * from "./KETBetriebsordner.vue?vue&type=script&lang=js&"
import style0 from "./KETBetriebsordner.vue?vue&type=style&index=0&id=3cd56d24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd56d24",
  null
  
)

export default component.exports